import React from "react";
import ContainerAcademy from "./ContainerAcademy/ContainerAcademy";
import Shared02Headings from "../../guestsharedcomponents/Shared02Headings/Shared02Headings";

const G06InsideTheAcademy = () => {
  return (
    <section className="t-ptb-10 t-overflow-x-hidden">
      <div className="t-container">
        <Shared02Headings
          options={{
            style_render: "992",
            main_container_css: "",
            container_mobile_styles: {
              "max-width": "60rem",
              "margin-bottom": "6rem",
            },
            container_desktop_styles: {},
            obj_heading: {
              main_text: "<span class='t-enlace'>Inside</span> LT Mastery",
              main_tag_version: "h2",
              main_text_css: "t-h-1",
              heading_mobile_styles: {
                color: "#fff",
                "font-weight": "900",
                "margin-bottom": "0.5rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },
            obj_support_heading: {
              main_text:
                "A closer look at how <span class='t-enlace'>real progress</span> happens.",
              main_tag_version: "h3",
              main_text_css: "t-h-4",
              heading_mobile_styles: {
                color: "#fff",
                "font-weight": "700",
                "margin-bottom": "1rem",
                "text-shadow":
                  "0 1px 2px rgba(0, 0, 0, 0.9), 0 3px 8px rgb(0 0 0), 0 8px 20px rgb(0 0 0)",
              },
              heading_desktop_styles: {},
            },

            obj_divider: {
              divider_mobile_styles: {
                width: "100%",
                background:
                  "linear-gradient(90deg, #e6c28b, #e6c28b, transparent)",
              },
              divider_desktop_styles: {},
            },
            obj_paragraph: false,
            obj_buttons: false,
            heading_version: "heading_01",
          }}
        />
      </div>

      <ContainerAcademy />
    </section>
  );
};

export default G06InsideTheAcademy;
